module.exports = __webpack_public_path__ + "img/sirima_ehmke_8.74c015c8.jpg";